import BaseController from "./BaseController";
import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import { Button$PressEvent } from "sap/ui/commons/Button";
import AdminDataService from "../util/AdminDataService";

export default class Organization extends BaseController {

    private readonly DIALOG_ID = "DialogUpdateOrganizationSettings";

    public async onInit(): Promise<void> {
        const oRouter = this.getOwnerComponent().getRouter();
        oRouter.getRoute("organization").attachPatternMatched(this.onObjectMatched, this);
    }

    onObjectMatched(oEvent: Route$PatternMatchedEvent): void {
        const args = oEvent.getParameter("arguments") as { id: string };
        AdminDataService.getOrganizationData(args.id);
        AdminDataService.getContracts();
        AdminDataService.getTeams();
        AdminDataService.getDepartments();
    }

    async onUpdateOrgSettings(oEvent: Button$PressEvent): Promise<void> {
        await this.openDialog(this.DIALOG_ID);
    }

    async onSaveDialog(oEvent: Button$PressEvent): Promise<void> {
        AdminDataService.updateOrganizationData();
        this.destroyDialog(this.DIALOG_ID);
    }

    onCloseDialog(): void {
        this.destroyDialog(this.DIALOG_ID);
    }
}
